import { forwardRef, ReactNode } from "react";

export type ContainerProps = {
  children: ReactNode;
  className?: string;
};

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  function Container({ children, className }, forwardedRef) {
    return (
      <div
        ref={forwardedRef}
        className={[
          `relative flex flex-col gap-8 items-center min-h-screen pt-14 pb-32 xl:pb-48 px-8 xl:px-56 2xl:px-72 scroll-mt-28`,
          className,
        ].join(" ")}
      >
        {children}
      </div>
    );
  },
);
